var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DefaultPageTemplate',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("商品一覧")]},proxy:true},{key:"content",fn:function(){return [_c('ItemList')]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }